var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{class:{
    thead: _vm.isExpand,
    highlighted: _vm.isHighlight
  },on:{"dblclick":function($event){return _vm.Table.$emit('row-dblclick', _vm.row)},"click":_vm.onClick}},_vm._l((_vm.Table.cols),function(col){return _c('table-cell',{key:col.prop || col.type,attrs:{"row":_vm.row,"col":col}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }